import type { RouteRecordRaw } from 'vue-router';

export const COMPANY_ROUTER: RouteRecordRaw = {
  path: '/admin/company',
  component: () => import('@/modules/admin/company/views/Company.vue'),
  name: 'Company',
  meta: {
    title: '조직 관리',
    requiresAuth: true,
  },
};
